import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SocialTwitter = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="social-twitter"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.86277 22.4307C17.2952 22.4307 22.4553 14.7887 22.4553 8.16218C22.4553 7.94424 22.4553 7.72845 22.4408 7.51263C23.4449 6.80344 24.3118 5.92495 25 4.91692C24.0645 5.32333 23.0707 5.58953 22.0561 5.70666C23.1248 5.07947 23.9272 4.09449 24.3098 2.93171C23.3015 3.51736 22.2017 3.92839 21.052 4.15058C19.1102 2.13057 15.8607 2.03298 13.7963 3.93263C12.4636 5.1572 11.8981 6.9827 12.3118 8.72406C8.1892 8.52033 4.3451 6.61674 1.74011 3.48471C0.378371 5.77659 1.07483 8.70737 3.32848 10.1783C2.51352 10.1548 1.71308 9.93975 0.999979 9.55144V9.61461C1.00207 12.002 2.72348 14.0571 5.11435 14.5306C4.35967 14.7322 3.56756 14.7617 2.8004 14.6169C3.47192 16.6589 5.39708 18.0591 7.59044 18.0989C5.77545 19.4945 3.53223 20.2527 1.22245 20.2502C0.81496 20.2477 0.407466 20.2257 0 20.1778C2.34717 21.649 5.07483 22.4306 7.86277 22.4257L12.0854 14.6652"
      />
    </svg>
  );
};
/* eslint-enable max-len */

SocialTwitter.defaultProps = {
  className: null,
};

SocialTwitter.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default SocialTwitter;
